import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DestinyService } from '../../services';
import { ButtonComponent, CarouselComponent, SectionWrapperModule } from '../../shared/components';
import { CardPlaceholderModule } from '../../shared/components/moleculas/card-placeholder/card-placeholder.module';
import { FilterTabsModule } from '../../shared/components/moleculas/filter-tabs/filter-tabs.module';
import { FiltersafeModule } from '../../shared/components/moleculas/filtersafe/filtersafe.module';
import { InputModule } from '../../shared/components/moleculas/input/input.module';
import { LightboxModule } from '../../shared/components/moleculas/lightbox/lightbox.module';
import { NewCardOfferModule } from '../../shared/components/moleculas/new-card-offer/new-card.module';
import { SelectModule } from '../../shared/components/moleculas/select/select.module';
import { PackageSectionComponent } from '../../shared/components/organisms/package-section/package-section.component';
import { FlightSearchComponent } from '../../shared/components/organisms/search/flight-search/flight-search.component';
import { DirectivesModule } from '../../shared/directives/directives.module';
import { PipesModule } from '../../shared/pipes/pipes.module';
import { BulletinComponent, SearchTabsComponent, VerifiedUserComponent } from './components';
import { HomeContentComponent } from './components/home-content/home-content.component';
import { HotSaleContactComponent } from './components/modals/hot-sale-contact/hot-sale-contact.component';
import { FeaturedLinksComponent } from './components/sections/featured-links/featured-links.component';
import { HomeComponent } from './home.component';

@NgModule({
  declarations: [
    HomeComponent,
    BulletinComponent,
    VerifiedUserComponent,
    SearchTabsComponent,
    HotSaleContactComponent,
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    RouterOutlet,
    FilterTabsModule,
    FiltersafeModule,
    ButtonComponent,
    ReactiveFormsModule,
    SelectModule,
    LightboxModule,
    InputModule,
    NgbTooltipModule,
    NewCardOfferModule,
    CardPlaceholderModule,
    NgbNavModule,
    PackageSectionComponent,
    PipesModule,
    SectionWrapperModule,
    FlightSearchComponent,
    CarouselComponent,
    FeaturedLinksComponent,
    HomeContentComponent,
  ],
  providers: [DestinyService, FormGroupDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class HomeModule {}
